/* L'Paige Judge.me reviews slider (sections/lp-reviews).
   Fetches the store's reviews from Judge.me's public all-reviews endpoint, keeps 5-star reviews
   (photo reviews first), builds cards with textContent only, and runs a scroll-snap slider with
   arrows, a progress bar, optional autoplay and a photo lightbox. */
(function () {
  if (window.__lpReviews) return;
  window.__lpReviews = true;

  var API = 'https://api.judge.me/reviews/all_reviews_js_based';
  var PRODUCT_API = 'https://api.judge.me/reviews/reviews_for_widget';
  var PHOTO_HOST = 'review-images.judgeme.com';
  var CACHE_MS = 30 * 60 * 1000;
  var STAR = '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false"><path d="M10 1.6l2.5 5.3 5.8.8-4.2 4.1 1 5.8L10 14.8l-5.1 2.8 1-5.8L1.7 7.7l5.8-.8z"/></svg>';

  function list(value) {
    return (value || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function safePhoto(url) {
    try {
      var u = new URL(url.replace(/&amp;/g, '&'), location.href);
      return u.protocol === 'https:' && u.hostname === PHOTO_HOST ? u : null;
    } catch (e) { return null; }
  }

  function photoAt(u, width) {
    var copy = new URL(u.href);
    copy.searchParams.set('width', width);
    copy.searchParams.set('quality', '80');
    return copy.href;
  }

  // "L'Paige Color-Changing Brown Lipstick | Moisturizing…" → "Color-Changing Brown"
  function shadeName(title) {
    var name = (title || '').split('|')[0].replace(/^\s*L[’']Paige\s+/i, '').replace(/\s+Lipstick\s*$/i, '').trim();
    return name;
  }

  function parse(html) {
    var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    return Array.prototype.map.call(doc.querySelectorAll('.jdgm-rev'), function (rev) {
      var rating = rev.querySelector('.jdgm-rev__rating');
      var link = rev.querySelector('.jdgm-rev__prod-link');
      var body = rev.querySelector('.jdgm-rev__body');
      var photos = [];
      rev.querySelectorAll('.jdgm-rev__pic-img').forEach(function (img) {
        var u = safePhoto(img.getAttribute('data-src') || img.getAttribute('src') || '');
        if (u && photos.indexOf(u.href) === -1) photos.push(u.href);
      });
      // Per-product widgets carry the product on the review itself rather than as a link.
      var href = link ? link.getAttribute('href') || '' : rev.getAttribute('data-product-url') || '';
      var productTitle = link ? link.textContent : rev.getAttribute('data-product-title') || '';
      return {
        id: rev.getAttribute('data-review-id') || '',
        score: rating ? Number(rating.getAttribute('data-score')) : 0,
        author: ((rev.querySelector('.jdgm-rev__author') || {}).textContent || '').trim(),
        title: ((rev.querySelector('.jdgm-rev__title') || {}).textContent || '').trim(),
        body: body ? body.textContent.replace(/\s+/g, ' ').trim() : '',
        verified: rev.getAttribute('data-verified-buyer') === 'true',
        photos: photos,
        product: productTitle ? shadeName(productTitle) : '',
        url: /^\/products\/[a-z0-9-]+$/i.test(href) ? href : ''
      };
    });
  }

  // Judge.me's "with_pictures" sort returns only photo reviews, so fetch those plus the newest pages.
  // With product IDs (data-products), fetch just those products' reviews instead.
  function load(shop, pagesNeeded, productIds) {
    var key = 'lp-reviews:v2:' + shop + (productIds.length ? ':' + productIds.join('.') : '');
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.t < CACHE_MS && cached.reviews.length) return Promise.resolve(cached.reviews);
    } catch (e) {}
    var base = '?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&per_page=25';
    var urls = [];
    if (productIds.length) {
      productIds.forEach(function (id) { urls.push(PRODUCT_API + base + '&page=1&product_id=' + encodeURIComponent(id)); });
    } else {
      urls.push(API + base + '&page=1&sort_by=with_pictures');
      for (var p = 1; p <= pagesNeeded; p++) urls.push(API + base + '&page=' + p);
    }
    var pages = urls.map(function (url) {
      return fetch(url, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('judge.me ' + r.status); return r.json(); })
        .catch(function () { return { html: '' }; });
    });
    return Promise.all(pages).then(function (results) {
      var reviews = [];
      results.forEach(function (json) { reviews = reviews.concat(parse(json && json.html || '')); });
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), reviews: reviews })); } catch (e) {}
      if (!reviews.length) throw new Error('no reviews');
      return reviews;
    });
  }

  function choose(reviews, opts) {
    var seen = {};
    var picked = reviews.filter(function (r) {
      if (r.score !== 5 || !r.id || seen[r.id] || opts.hideReviews.indexOf(r.id) > -1) return false;
      seen[r.id] = true;
      r.photos = r.photos.filter(function (src) {
        return !opts.hidePhotos.some(function (needle) { return needle && src.indexOf(needle) > -1; });
      });
      var len = (r.title + ' ' + r.body).trim().length;
      return r.photos.length ? len >= opts.minPhoto : r.body.length >= opts.minText;
    });
    picked.sort(function (a, b) { return (b.photos.length ? 1 : 0) - (a.photos.length ? 1 : 0); });
    return picked.slice(0, opts.count);
  }

  function card(r, opts, index) {
    var li = el('li', 'lp-rv__card' + (r.photos.length ? ' lp-rv__card--photo' : ''));
    li.style.setProperty('--i', index % 4);
    if (r.photos.length) {
      var btn = el('button', 'lp-rv__photo');
      btn.type = 'button';
      btn.setAttribute('aria-label', opts.photoLabel + (r.author ? ' — ' + r.author : ''));
      btn.dataset.full = photoAt(new URL(r.photos[0]), 1024);
      btn.dataset.caption = r.author + (r.product ? ' · ' + r.product : '');
      var img = el('img');
      img.src = photoAt(new URL(r.photos[0]), 600);
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 600; img.height = 600;
      btn.appendChild(img);
      if (r.photos.length > 1) btn.appendChild(el('span', 'lp-rv__photo-count', '+' + (r.photos.length - 1)));
      li.appendChild(btn);
    }
    var bodyWrap = el('div', 'lp-rv__body');
    if (!r.photos.length) bodyWrap.appendChild(el('span', 'lp-rv__mark', '“')).setAttribute('aria-hidden', 'true');
    var main = el('div', 'lp-rv__main');
    var stars = el('p', 'lp-rv__stars');
    stars.setAttribute('aria-label', '5 out of 5 stars');
    stars.innerHTML = STAR + STAR + STAR + STAR + STAR;
    main.appendChild(stars);

    var titleLower = r.title.toLowerCase().replace(/[.!]+$/, '');
    var showTitle = r.title && r.body.toLowerCase().indexOf(titleLower) !== 0;
    if (showTitle) main.appendChild(el('h3', 'lp-rv__title', r.title));
    var text = el('div', 'lp-rv__text');
    text.appendChild(el('p', null, r.body || r.title));
    main.appendChild(text);
    var more = el('button', 'lp-rv__more', opts.readMore);
    more.type = 'button';
    more.hidden = true;
    main.appendChild(more);
    bodyWrap.appendChild(main);

    var who = el('p', 'lp-rv__who');
    who.appendChild(el('strong', null, r.author || 'Lipstick Lover'));
    var meta = el('span');
    if (r.verified) {
      meta.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      meta.appendChild(document.createTextNode(opts.verified));
    }
    who.appendChild(meta);
    if (r.product) {
      var prod = r.url ? el('a', 'lp-rv__product', r.product) : el('span', 'lp-rv__product', r.product);
      if (r.url) prod.href = r.url;
      who.appendChild(prod);
    }
    bodyWrap.appendChild(who);
    li.appendChild(bodyWrap);
    return li;
  }

  function init(root) {
    if (root.__lpReviews) return;
    root.__lpReviews = true;
    var d = root.dataset;
    var track = root.querySelector('[data-lp-track]');
    var prev = root.querySelector('[data-lp-prev]');
    var next = root.querySelector('[data-lp-next]');
    var bar = root.querySelector('[data-lp-progress]');
    var dialog = root.querySelector('[data-lp-lightbox]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var opts = {
      count: Number(d.count) || 18,
      minText: Number(d.minText) || 0,
      minPhoto: Number(d.minPhoto) || 0,
      hideReviews: list(d.hideReviews),
      hidePhotos: list(d.hidePhotos),
      verified: d.verified || 'Verified buyer',
      readMore: d.readMore || 'Read more',
      readLess: d.readLess || 'Show less',
      photoLabel: d.photoLabel || 'Customer photo'
    };

    function step() {
      var first = track.querySelector('.lp-rv__card');
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function update() {
      var max = maxScroll();
      var x = track.scrollLeft;
      prev.disabled = x <= 2;
      next.disabled = x >= max - 2;
      var visible = max > 0 ? track.clientWidth / track.scrollWidth : 1;
      bar.style.width = Math.max(visible * 100, 8) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (x / max) * (100 / visible - 100) : 0) + '%)';
      root.classList.toggle('is-static', max <= 2);
    }
    function go(dir) {
      var max = maxScroll();
      var target = track.scrollLeft + dir * step();
      if (dir > 0 && track.scrollLeft >= max - 2) target = 0; // wrap round at the end
      track.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { stop(); go(-1); });
    next.addEventListener('click', function () { stop(); go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(-1); }
    });

    // autoplay: slow, pauses on hover/focus/touch, stops for good once the visitor takes over
    var timer = null;
    var stopped = false;
    var seconds = Number(d.autoplay) || 0;
    function play() {
      if (stopped || !seconds || reduce || timer) return;
      timer = setInterval(function () { if (!document.hidden) go(1); }, seconds * 1000);
    }
    function pause() { clearInterval(timer); timer = null; }
    function stop() { stopped = true; pause(); }
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', play);
    track.addEventListener('pointerdown', stop, { passive: true });
    track.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stop(); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { entries[0].isIntersecting ? play() : pause(); }, { threshold: 0.35 }).observe(track);
    }

    // read more: only on cards whose text is actually clipped
    function markClamped() {
      track.querySelectorAll('.lp-rv__card').forEach(function (c) {
        var text = c.querySelector('.lp-rv__text');
        var btn = c.querySelector('.lp-rv__more');
        if (!text || !btn || c.classList.contains('is-open')) return;
        btn.hidden = text.scrollHeight <= text.clientHeight + 2;
      });
    }
    track.addEventListener('click', function (e) {
      var more = e.target.closest('.lp-rv__more');
      if (more) {
        var c = more.closest('.lp-rv__card');
        var open = c.classList.toggle('is-open');
        more.textContent = open ? opts.readLess : opts.readMore;
        stop();
        return;
      }
      var photo = e.target.closest('.lp-rv__photo');
      if (photo && dialog) {
        stop();
        dialog.querySelector('[data-lp-lightbox-img]').src = photo.dataset.full;
        dialog.querySelector('[data-lp-lightbox-cap]').textContent = photo.dataset.caption || '';
        if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      }
    });
    if (dialog) {
      dialog.querySelector('[data-lp-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }

    function render(items) {
      track.innerHTML = '';
      items.forEach(function (node) { track.appendChild(node); });
      root.classList.add('is-ready');
      update();
      requestAnimationFrame(markClamped);
      track.querySelectorAll('img').forEach(function (img) { img.addEventListener('load', markClamped, { once: true }); });
      window.addEventListener('resize', markClamped);
    }
    function fallback() {
      var tpl = root.querySelector('[data-lp-fallback]');
      var nodes = tpl ? Array.prototype.slice.call(tpl.content.cloneNode(true).children) : [];
      if (!nodes.length) { root.hidden = true; return; }
      render(nodes);
    }

    var pagesNeeded = Math.min(3, Math.max(1, Math.ceil(opts.count / 10)));
    load(d.shop, pagesNeeded, list(d.products))
      .then(function (reviews) {
        var chosen = choose(reviews, opts);
        if (!chosen.length) return fallback();
        render(chosen.map(function (r, i) { return card(r, opts, i); }));
      })
      .catch(fallback);
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-lp-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
